/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDownloadModel } from '../../models/file-download-model';
import { ResultsReportRequestModel } from '../../models/results-report-request-model';

export interface OrgExtResultsReportOrganizationIdPersonIdPost$Params {
  organizationId: string;
  personId: string;
      body?: ResultsReportRequestModel
}

export function orgExtResultsReportOrganizationIdPersonIdPost(http: HttpClient, rootUrl: string, params: OrgExtResultsReportOrganizationIdPersonIdPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<FileDownloadModel>> {
  const rb = new RequestBuilder(rootUrl, orgExtResultsReportOrganizationIdPersonIdPost.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('personId', params.personId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<FileDownloadModel>;
    })
  );
}

orgExtResultsReportOrganizationIdPersonIdPost.PATH = '/OrgExt/ResultsReport/{organizationId}/{personId}';
